<template>
  <b-modal ref="mawashiModal" title="回し表出力" :no-close-on-backdrop="true" @ok="handleOk" okTitle="出力" cancelTitle="キャンセル">
    <b-overlay :show="overlayShow" rounded="sm">
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group label="挙式日" label-for="wedding-date" invalid-feedback="必須項目です">
          <b-form-datepicker id="wedding-date" v-model="weddingDate" class="mb-2"></b-form-datepicker>
        </b-form-group>
        <b-form-group label="施設" label-for="facility">
          <b-form-select id="wedding-date" v-model="facility" :options="facilities"></b-form-select>
        </b-form-group>
      </form>
    </b-overlay>
  </b-modal>
</template>

<script>
import FacilityListModel from '@/models/FacilityListModel'
import MawashiCsvModel from '@/models/MawashiCsvModel'
import MawashiSheetsModel from '@/models/MawashiSheetsModel'
import SaveCSV from 'file-saver'
export default {
  name: 'MawashiModal',
  data () {
    return {
      type: '',
      overlayShow: false,
      weddingDate: '',
      facilities: [],
      facility: null,
      prodBaseCode: ''
    }
  },
  async mounted () {
    // 日付の初期値を今日に設定
    const date = new Date()
    this.weddingDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`

    // 施設一覧の取得と初期値の設定
    const facilities = await FacilityListModel.getApi(this.$bvModal, {}, () => {})
    for (const facility of facilities['facilities']['records']) {
      this.facilities.push({
        value: facility['施設名']['value'],
        text: facility['施設名']['value']
      })
    }
    this.facility = this.facilities[0]['value']
    this.prodBaseCode = facilities['facilities']['records'][0]['制作拠点コード']['value']
  },
  methods: {
    showModal (type) {
      this.type = type
      this.$refs.mawashiModal.show()
    },
    handleOk (bvModalEvent) {
      bvModalEvent.preventDefault()
      this.handleSubmit()
    },
    handleSubmit () {
      this.overlayShow = true

      const reqData = {
        weddingDate: this.weddingDate,
        facilityName: this.facility,
        prodBaseCode: this.prodBaseCode
      }

      const closeModal = () => {
        this.overlayShow = false
        this.$refs.mawashiModal.hide()
      }

      if (this.type === 'csv') {
        MawashiCsvModel.postApi(this.$bvModal, reqData, (res) => {
          let bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          let blob = new Blob([bom, res.data.content], {type: res.headers['content-type']})
          console.info(res.fileName)
          console.info(res.data.fileName)
          SaveCSV(blob, res.data.fileName)
        }, closeModal)
      } else if (this.type === 'excel') {
        MawashiSheetsModel.postApi(this.$bvModal, reqData, (res) => {
          if (res.data.status === 'success') {
            window.open(res.data.items.filePath, '_blank')
          }
        }, closeModal)
      } else {
        closeModal()
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/MawashiModal.vue